import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Box } from '../Box/index.js';

const StyledStack = styled(Box).withConfig({
  displayName: "Stack__StyledStack",
  componentId: "sc-q3mkwx-0"
})(["> * + *{margin-left:", ";margin-top:", ";}"], _ref => {
  let {
    flexDirection,
    spacing
  } = _ref;
  return flexDirection === 'row' ? themeGet(`space.${spacing}`) : null;
}, _ref2 => {
  let {
    flexDirection,
    spacing
  } = _ref2;
  return flexDirection === 'column' ? themeGet(`space.${spacing}`) : null;
});
/**
 * Stack is a layout utility component that makes it easy to stack elements
 * together and apply a space between them. It is composed of the `Flex` component.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/stack#usage)
 * - [Props](https://blockparty.endpoint.com/components/stack#props)
 * <br />
 *
 * #### Default Values
 * @property spacing='space40' - Space between Stacked components
 * @property direction='column' - Direction of stacked items
 *
 */
const Stack = /*#__PURE__*/forwardRef((_ref3, forwardedRef) => {
  let {
    children,
    spacing = 'space40',
    direction = 'column',
    ...rest
  } = _ref3;
  return /*#__PURE__*/React__default.createElement(StyledStack, _extends({
    ref: forwardedRef,
    display: "flex",
    flexDirection: direction,
    spacing: spacing
  }, rest), children);
});

export { Stack };
